import React from 'react';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react';
import { MembershipGroupStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class MembershipGroupCreate extends React.Component {

  onCreate = name => {
    MembershipGroupStore.create({data: {name, site_id: Cookies.get('site_id')}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Create a Membership Group'
        onCreate={this.onCreate}
      />
    );
  }
}

export default MembershipGroupCreate;
